import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/shared/shared-module';
import {MatChipsModule} from '@angular/material/chips';
import {MatDividerModule} from '@angular/material/divider';
import { Api } from 'src/app/services/api';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { resolve } from 'path';


@Component({
  selector: 'app-messagedetails',
  imports: [SharedModule, CommonModule,MatDialogModule, MatChipsModule, MatDividerModule],
  templateUrl: './messagedetails.html',
  styleUrl: './messagedetails.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Messagedetails implements OnInit {
  constructor(public dialogRef: MatDialogRef<Messagedetails>,private apiservice: Api,private sanitizer: DomSanitizer){

  }

   data:any = inject(MAT_DIALOG_DATA);
title = 'Título del mensaje';
  subtitle?: string = 'Subtítulo opcional';
  message = 'Contenido del mensaje…';
  showReply = false;
  replyText = '';
  today  = moment().format('MMM DD, YYYY  HH:mm:ss');
ngOnInit() {
  console.log('message detils ir id ', this.data);
  if(this.data.tipo == "Freshman"){
    this.data.Mmessage =this.sanitizer.bypassSecurityTrustHtml(`<b>${this.data.nombre} ${this.data.apellidop ? this.data.apellidop : '' }</b>, ${this.data.message} <br><b>Alta:</b> ${moment(this.data.alta, 'YYYY-MM-DD').format('MMM DD, YY')} <b>Grupo:</b> ${this.data.gpon} <b>Modalidad:</b> ${this.data.modalidad} `);
    }
    if(this.data.tipo == "Vencido"){
    this.data.Mmessage =this.sanitizer.bypassSecurityTrustHtml(`<b>${this.data.alumno} ${this.data.apellidop}</b>, ${this.data.message} <br>Si no contacta administración se le debe suspender el servicio. <b>Grupo:</b> ${this.data.grupo} <b>Modalidad:</b> ${this.data.modalidad} `);
    }
      if(this.data.tipo == "caldata"){
    // this.data.Mmessage = this.sanitizer.bypassSecurityTrustHtml(`${this.data.Mmessage}<br><br>\n\n <b>Asignado por</b> ${this.data.assigno}`);
     let horario = this.data.startTime && this.data.endTime ? `<b>Horario:</b> ${moment(this.data.date, 'YYYY-MM-DD').format('MMM DD, YY')}, ${this.data.startTime} - ${this.data.endTime}` : '';
      this.data.Mmessage = this.sanitizer.bypassSecurityTrustHtml(`${this.data.message}<br> ${horario}<br><br>\n\n <b>Asignado por</b> ${this.data.assigno}`);

  }

    //console.log('message detils ', this.data);
}
  onAcknowledge() {
    // TODO: emit/close with acknowledge
            this.dialogRef.close('acknowledge');

  }

  onSendReply(text: string) {
    // TODO: post reply, then optionally close
        this.dialogRef.close('replysent');

  }

  onClose() {
    // close dialog
    this.dialogRef.close('closed');
  }
  udateycerrar(): Promise<any>{
    console.log('corro ');
    return new Promise((resolve, reject)=>{

if(this.replyText.length <= 4){
  let r:any;

Swal.fire({
  icon: 'error',
  title: 'Oops...',
  text: 'Debes agregar un comentario de al menos 10 caracteres.',
  timer: 2000,
});
r = { mensaje:'Debes agregar un comentario de al menos 10 caracteres.', ok:'false'}

return;
}
console.log(this.data.tipo )
  let user = localStorage.getItem('nombre') + ' ' + localStorage.getItem('apellido');
    if(this.data.tipo == "Freshman"){
      let payload = {
        // id: this.data.id,
        tipo:'Freshman',
        sucursal:this.data.sucursal,
        message: `<b>${user}</b> ha dado seguimiento al alumno, <b>${this.data.nombre} ${this.data.apellidop}</b>, <b>Grupo:</b> ${this.data.gpon} <b>Modalidad:</b> ${this.data.modalidad} <br>Nota: ${this.replyText}. <br>Cerrado: ${this.today}`,
      };
      // this.apiservice.addItem(payload,'messages').subscribe({
      //   next: (data) => {
          //console.log('Notificación actualizada:', data);
          // this.dialogRef.close('updated');
          let p ={
            freshman: 0,
            log: `Followup de freshman hecho por ${user}, ${this.today}`,
            id: this.data.id,
          }
          this.apiservice.updateData('alumnos',p).subscribe({
            next:(updated)=>{
              //console.log('Freshman updated:', updated);
              resolve({ mensaje:'Freshman followup cerrado', ok:true});

            },error:(error)=>{
              reject({mensaje:'Error al actualizar notificación:'+ error, ok:false})
            }
          });
      //   },
      //   error: (error) => {
      //     console.error({mensaje:'Error al actualizar notificación:'+ error, ok:false});
      //         reject({mensaje:'Error al actualizar notificación:'+ error, ok:false})
      //   }
      // });
    }else if(this.data.tipo == "Faltas"){
           this.apiservice.DelDataGEn('messages',this.data.id).subscribe({
            next:(updated)=>{
              //console.log('Freshman updated:', updated);
              resolve({ mensaje:'Se confirmo el seguimiento a faltas', ok:true});

            },error:(error)=>{
              reject({mensaje:'Error al actualizar notificación:'+ error, ok:false})
            }
          });
  }else if(this.data.tipo == "caldata"){
      let payload = {
        id: this.data.id,
        tipo:'caldata',
        completed:1,
        replied:1,
        closednote: `<b>${user}</b> ha dado seguimiento a la asignación ${this.data.nombre}, <br>Nota: ${this.replyText}. <br>Cerrado: ${this.today}`,
      };
      this.apiservice.updateData('caldata',payload).subscribe({
        next: (data) => {
          //console.log('Notificación actualizada:', data);
          // this.dialogRef.close('updated');
                      resolve({ mensaje:'Asignación cerrada', ok:true});

        },
        error: (error) => {
          console.error({mensaje:'Error al actualizar notificación:'+ error, ok:false});
              reject({mensaje:'Error al actualizar asignación:'+ error, ok:false})
        }
      });
  }
    });
  }
  responder(){
    Swal.fire({
  title: "¿Estás seguro?",
  html: `Una vez agregada la nota esta tarea será competada y cerrada,<br> ¿Deseas responder y cerrar esta tarea?`,
  showDenyButton: true,
  showCancelButton: false,
  confirmButtonText: "Confirmar",
  denyButtonText: `Cancelar`
}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  console.log(result);
  if (result.isConfirmed) {
      console.log('confirme ');

    this.udateycerrar().then((res)=>{
      console.log('borrar ', res);
      if(res.ok){

  this.apiservice.NotificationremoveById(this.data.id);

          Swal.fire("Guardado", res.mensaje, "success");
           this.dialogRef.close('updated');
      }else{
        if(res.mensaje == 'Debes agregar un comentario de al menos 10 caracteres.'){
          return;
        }
        Swal.fire("Error", res.mensaje, "error");
        this.dialogRef.close('error');
      }
      });

  } else if (result.isDenied) {
    //  Swal.fire("Changes are not saved", "", "info");
  }
});
  }
   showMessageWithAnimation(text: string, type: 'success' | 'error' | 'warning' | 'info'): void {
          let messageText = text;
          let messageType = type;

      Swal.fire({
        // title: "loading...",
        text: messageText,
        icon: messageType,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: false,

      });
          // Auto-hide message after 5 seconds

        }


}
